import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[layoutTemplate]'
})
export class LayoutTemplateDirective {
  @Input() layoutTemplate: string;

  constructor(public template: TemplateRef<unknown>) { }

  getType(): string {
    return this.layoutTemplate;
  }
}
